'use client';

import { FC } from 'react';

import { Pencil } from '../Icons';

import styles from './EditButton.module.scss';

const DEFAULT_ARIA_LABEL = 'Edit';
const ICON_SIZE = 16;

export type EditButtonProps = {
  onClick: (e: React.MouseEvent) => void;
  ariaLabel?: string;
};

export const EditButton: FC<EditButtonProps> = ({ onClick, ariaLabel = DEFAULT_ARIA_LABEL }) => {
  return (
    <button className={styles.button} onClick={onClick} type="button" aria-label={ariaLabel}>
      <Pencil size={ICON_SIZE} />
    </button>
  );
};
